import { CIMSModal } from 'components/CIMSModal'
import { simpleSuccessNotification } from 'hooks/notificationHandler'
import React from 'react'
import {
  useRouteDesignSubmittalMutation,
  useGiveDesignSubmittalDispositionMutation,
} from 'schema'
import { DesignSubmittalStatus } from 'shared'
import { DisciplineAction } from './DisciplineAction'
import { RouterReview } from './RouterReview'
import { useDesignSubmittalLogContext } from '../../../../DesignSubmittalLogContext'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { RouterReviewValues } from './RouterReview/types'
import { DisciplineActionValues } from './DisciplineAction/types'

export const AdvancementModal: React.FC = () => {
  const {
    refetch,
    advancementModal: { visible, toggle, state },
  } = useDesignSubmittalLogContext()
  // route
  const [route, { loading: routeLoading }] = useRouteDesignSubmittalMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      routeDesignSubmittal: {
        designSubmittal: { sharePointFolderName },
      },
    }) =>
      simpleSuccessNotification(
        `${sharePointFolderName} successfully sent to ${DesignSubmittalStatus.DisciplineAction}`
      ),
  })
  // disposition
  const [giveDisposition, { loading: dispositionLoading }] =
    useGiveDesignSubmittalDispositionMutation({
      ...DefaultMutationHookOptions,
      onCompleted: ({
        giveDesignSubmittalDisposition: {
          designSubmittal: { sharePointFolderName },
        },
      }) =>
        simpleSuccessNotification(
          `${sharePointFolderName} successfully ${DesignSubmittalStatus.ReturnedToDesignBuilder} `
        ),
    })
  return (
    <CIMSModal
      title={state?.status}
      visible={visible}
      width="narrow"
      loading={routeLoading || dispositionLoading}
      onCancel={() => toggle(null)}
      onOk={async (values) => {
        if (state?.status === DesignSubmittalStatus.RouterReview) {
          const { disciplineIds, actionIds, contractDueDate, comment } =
            values as RouterReviewValues
          await route({
            variables: {
              routeDesignSubmittalInput: {
                id: state?.id,
                actionIds,
                disciplineIds,
                contractDueDate: contractDueDate.toISOString(),
                comment,
              },
            },
          })
          await refetch()
        } else if (state?.status === DesignSubmittalStatus.DisciplineAction) {
          const { disposition, comment } = values as DisciplineActionValues
          await giveDisposition({
            variables: {
              giveDesignSubmittalDispositionInput: {
                id: state?.id,
                disposition,
                comment,
              },
            },
          })
          await refetch()
        }
        toggle(null)
      }}
    >
      {state?.status === DesignSubmittalStatus.RouterReview && <RouterReview />}
      {state?.status === DesignSubmittalStatus.DisciplineAction && (
        <DisciplineAction />
      )}
    </CIMSModal>
  )
}
